import { Group } from '@studio/design-system/form';
import type { HtmlAttributes } from '@studio/design-system/props';
import * as Select from '@studio/design-system/select';
import type { Settings } from '@studio/models/video';
import { Protocol } from '@studio/models/video';
import type { Configuration } from '@studio/models/video/ndi';
import { toAccessor } from '@studio/react-utils';
import { useLatestFn } from '@studio/react-utils/hooks';
import type { ReactElement } from 'react';
import { shallow } from 'zustand/shallow';
import { Preview } from '../../preview/index.js';
import { useProducer, useStore } from '../../store/hooks.js';
import { Columns } from '#~/common/editor/index.js';
import { Ndi as _Ndi } from '#~/video/components/editor/index.js';
import { Lang } from '#~/video/index.js';
import { useAnalytics } from '#~/analytics/hooks/index.js';
import { EVENT_CATEGORIES, EVENT_NAMES } from '#~/analytics/constants/index.js';

/** `<Ndi>` video component. */
export const Ndi = (props: HtmlAttributes): ReactElement => {
  const producer = useProducer();
  const { track } = useAnalytics();

  const settings = useStore(
    ({ candidate }) =>
      // We know this is a normalized NDI configuration.
      candidate.video as Settings<Configuration>,
    shallow
  );

  const handleChange = useLatestFn((value: Settings) => {
    producer((draft) => {
      draft.candidate.video = value;

      // Track the NDI video settings confirmation
      track(EVENT_NAMES.CONFIRM_NDI_VIDEO_SETTINGS, EVENT_CATEGORIES.VIDEO_SOURCES, {
        sourceType: 'NDI',
        sourceProtocol: Protocol.NDI,
        settingsConfirmed: true,
        value
      });
    });
  });

  const protocol = Protocol.NDI;

  return (
    <Columns {...props}>
      <Columns.Column>
        <h3 className='m-0'>Video settings</h3>

        <Group label='Video protocol'>
          <Select.Root value={protocol}>
            <Select.Trigger>
              <Select.Value />
            </Select.Trigger>

            <Select.Content>
              <Select.Item value={protocol}>{Lang.protocol[protocol]}</Select.Item>
            </Select.Content>
          </Select.Root>
        </Group>

        <_Ndi settings={toAccessor(settings, handleChange)} {...props} />
      </Columns.Column>

      <div>
        <h3>Video preview</h3>

        <Preview />
        {/* <Inverted className='mt-12' /> */}
      </div>
    </Columns>
  );
};
